import {Chip} from "@mui/material";
import React from "react";


const Model23FeatureChip = ({feature, onDelete}) => {
    {
        let s = `ID: ${feature.properties.id}`
        if (feature.properties.station) {
            s = `${feature.properties.station?.code}` + " - " + s;
        }
        return <Chip label={s}
                     size="small"
                     color="primary"
                     onDelete={onDelete}/>
    }
}


export default Model23FeatureChip;